<template>
  <modal
    ref="modal"
    variant="external-link"
    :cta-action="openExternalLink"
    :cta-text="ctaText"
    :cta-disabled="isLoading"
    :custom-class="isLoading ? 'loading' : undefined"
    @close="clear"
  >
    <template v-slot:body>
      <transition name="fade" mode="out-in">
        <div v-if="innerBody" v-html="innerBody" key="body" />
        <div v-else-if="errors.length > 0" key="errors">
          <div class="error-box">
            <span v-html="errorsTemplate" />
          </div>
        </div>
        <div v-else class="loading-data" key="loading">
          <span class="icon-loading" />
        </div>
      </transition>
    </template>
  </modal>
</template>

<script>
  import axios from 'axios'
  import { getApiUrl } from '@utils/api-helpers'
  import TabTrapMixin from '@mixins/tab-trap'
  import { mapState } from 'vuex'
  import Cookies from 'js-cookie'

  export default {
    name: 'ExternalLinkModal',
    mixins: [TabTrapMixin],
    data: () => ({
      innerBody: null,
      href: null,
      target: null,
      contentId: null,
      ctaText: null,
      errors: []
    }),
    computed: {
      ...mapState('global', ['lang']),
      errorsTemplate() {
        return this.errors.join('<br>')
      },
      isLoading() {
        return !this.innerBody && this.errors.length === 0
      },
      isSevenRoomsDomain() {
        return this.href && this.href.includes('sevenrooms.com')
      },
      openPopup() {
        return this.target && this.target.includes('external:')
      }
    },
    watch: {
      firstFocusableEl(val) {
        if (val) {
          this.firstFocusableEl.focus()
        }
      },
    },
    mounted() {
      document.addEventListener('click', this.handleOnClick)
    },
    methods: {
      handleOnClick(e) {
        const link = e.target.closest('a')

        if (!link || !link.href) {
          return
        }
        this.href = link.href
        this.target = link.target

        if (this.isSevenRoomsDomain || this.openPopup) {
          e.preventDefault()
        }
        if (this.isSevenRoomsDomain) {
          this.updateUrlAndNavigate(e)
        } else if (this.openPopup) {
          this.handlePopup(e)
        }
      },
      updateUrlAndNavigate(e) {
        let finalUrl = this.href
        const cookie = Cookies.get('mktSrc')

        if (cookie) {
          const url = new URL(this.href)
          const params = new URLSearchParams(url.search)

          params.delete('src')
          url.search = `src=${cookie}&${params.toString()}`
          finalUrl = url.toString()
        }
        if (!this.openPopup) {
          if (cookie) {
            Cookies.remove('mktSrc')
          }
          window.location.href = finalUrl
          return
        }
        this.handlePopup(e, finalUrl)
      },
      handlePopup(e, newUrl) {
        const contentId = this.target.split(':')[1]
        if (!contentId) {
          throw new Error('No content ID')
        }
        if (newUrl) {
          this.href = newUrl.toString()
        }
        this.contentId = contentId
        this.$refs.modal.activate(e)
        this.getInnerBody()
      },
      openExternalLink() {
        window.open(this.href, '_external').focus()
        this.$refs.modal.deactivate()
        if (Cookies.get('mktSrc') && this.isSevenRoomsDomain) Cookies.remove('mktSrc')
      },
      async getInnerBody() {
        this.errors = []
        try {
          const { data } = await axios.post(
            getApiUrl('api/v1/pagecontent/external-link-modal'),
            {
              linkId: this.contentId,
              language: this.lang
            }
          )
          this.innerBody = `<h6 class="title">${data.externalLinkModal.title}</h6><br>
          <div class="content-body">${data.externalLinkModal.body}</div><br>
          <div class="external-terms">${data.externalLinkModal.terms}</div>`
          this.terms = data.externalLinkModal.terms
          this.ctaText = data.externalLinkModal.buttonText
        } catch (err) {
          if (err.errors) {
            this.errors = err.errors
          }
        }
      },
      clear() {
        setTimeout(() => {
          this.innerBody = null
          this.href = null
          this.contentId = null
          this.ctaText = null
          this.errors = []
        }, 400)
      }
    }
  }
</script>
